import React from 'react';
import { useCountUp } from '../hooks/useCountUp';

// Parses values produced by fmtMoney() (es-AR format: "$1.234.567")
// and plain integers ("42"). Returns null for non-numeric values like "—".
function parseValue(str) {
  if (!str || str === '—') return null;
  const s        = String(str).trim();
  // Un PORCENTAJE no se anima: es un valor ya formateado («4,4 %»), y parsearlo como número le
  // comía el decimal y el signo («4.4%» → «44»). Se muestra verbatim (bug R1, 22-oct-2026).
  if (s.includes('%')) return null;
  const hasDollar = s.startsWith('$');
  // In es-AR, periods are thousands separators (no decimal places used here)
  const digits   = s.replace('$', '').replace(/\./g, '');
  const num      = parseFloat(digits);
  if (isNaN(num)) return null;
  return { num, hasDollar };
}

function formatValue(value, { hasDollar }) {
  const rounded = Math.round(value);
  if (hasDollar) {
    return '$' + rounded.toLocaleString('es-AR', { maximumFractionDigits: 0 });
  }
  // Enteros: mismo separador de miles que el resto de la app (1.675, no 1675). Sin esto la
  // animación de count-up terminaba en String(rounded) y comía el punto que traía el valor.
  return rounded.toLocaleString('es-CO', { maximumFractionDigits: 0 });
}

export default function AnimatedNumber({ value }) {
  const parsed   = parseValue(value);
  const animated = useCountUp(parsed ? parsed.num : null, { enabled: parsed !== null });

  if (!parsed) return <>{value}</>;
  return <>{formatValue(animated, parsed)}</>;
}
